export default "__VITE_ASSET__Avp4UA____"